

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};
Monet.UI.Fields.Icon = Monet.UI.Fields.Icon || {};

Monet.UI.Fields.Icon = (function () {

    function Icon () {

        Monet.UI.Fields.TextField.apply(this, arguments);

        var value = null;
        var link = document.createElement('a');
        link.href = '';

        this.getValue = function () {
            return value;
        };

        this.setValue = function (val) {
            value = val;
            link.className = value.className;
            link.href = value.href;
        };

        this.clear = function () {
            this.setValue("");
        };

        this.render = function () {
            this.input = {value : link};
            this.rootEl.appendChild(link);
            return this.rootEl;

        };
    }

    return Icon;

}());